export const categoryList = [
    {
        name: 'Wedding',
        occasions: ['Wedding', 'Engagement', 'Reception', 'Pre Wedding Function', 'Other Wedding Events']
    },
    {
        name: 'Corporate',
        occasions: ['Corporate Party', 'Conference', 'Team Outing', 'Meeting', 'Exhibition', 'Other Corporate Events']
    },
    {
        name: 'Social',
        occasions: ['Birthday Party', 'First Birthday Party', 'Anniversary', 'Pool Party', 'Social Get Together']
    }
];

export const Category_Title = 'Select Occasion';
